import apiConstants from './Constant/ApiConstant'
import http from './core/HttpService'
import { ApiFailure } from 'index'

/**
 * Assessment service failures use the shared API error state so every failed
 * request from this service opens the existing connection error modal.
 */
const setApiError = (error: any) => {
  ApiFailure.setApiError(true, error)
}

export const getQuestions = async (
  assessmentType: string,
  assessmentId: number,
  classroomId: number
): Promise<any> => {
  try {
    const { data } = await http.get(
      `${apiConstants.Student}/classrooms/${classroomId}/${assessmentType}/${assessmentId}?tts=true`
    )
    return Promise.resolve(data)
  } catch (error) {
    setApiError(error)
    return Promise.reject(error)
  }
}

export const updateQuestions = async (
  updatedQuestions: any,
  assessmentType: string
): Promise<any> => {}

export const submitAnswer = async (
  assessmentType: string,
  assessment_id: number,
  question_number: number,
  response: number,
  classroomId: number,
  time_in_minutes: number,
  clear_answer: boolean = false
) => {
  try {
    const { data } = await http.put(
      `${apiConstants.Student}/${assessmentType}/${assessment_id}/${question_number}/${response}/${classroomId}?time_in_minutes=${time_in_minutes}&clear_answer=${clear_answer}`
    )

    return Promise.resolve(data)
  } catch (error) {
    setApiError(error)
    return Promise.reject(error)
  }
}
export const toggleBookmark = async (
  assessmentType: string,
  assessment_id: number,
  classroomId: number,
  bookMark: boolean,
  quesId: number
) => {
  try {
    const { data } = await http.put(
      `student/${assessmentType}/${assessment_id}/classrooms/${classroomId}`,
      { bookmark: bookMark, question_id: quesId }
    )
    return Promise.resolve(data)
  } catch (error) {
    setApiError(error)
    return Promise.reject(error)
  }
}

export const submitAssessment = async (
  assessmentType: string,
  assessment_id: number,
  classroom_id: number,
  studentAnswers: any
) => {
  try {
    const { data } = await http.post(
      `${apiConstants.Student}/classrooms/${classroom_id}/${assessmentType}/${assessment_id}/submit`,
      studentAnswers
    )

    return Promise.resolve(data)
  } catch (error) {
    setApiError(error)
    return Promise.reject(error)
  }
}

export const putTestTimeService = async (
  test_id: number,
  assessmentType: string,
  classroom_id: any
) => {
  try {
    await http.put(
      `${apiConstants.TestTime}/${test_id}/classrooms/${classroom_id}/type/${assessmentType}?time_in_seconds=60`
    )
  } catch (error) {
    setApiError(error)
    console.error(error)
  }
}
